import React, { useState } from 'react';
import OrderPage from './components/OrderPage';
import { orderStatus } from '../../../constants/orderStatus';
import { useSelector } from 'react-redux';
import { apiCall } from '../../../middlewares/api';

const Invoiced = () => {
  const isAdmin = useSelector(
    (state) => state?.user?.preferences?.isAdmin || false
  );

  const username =  useSelector((state) => state?.user?.user?.username || '');

  const uploadButtonProps = {
    url: 'https://vs-system-templates.s3.ap-south-1.amazonaws.com/Invoice.xlsx',
    text: 'Upload Orders Details',
    infoModalTitle: 'Invoiced Orders',
    targetStatus: 'Invoiced',
    handleSubmit: async (data) => {
      try {
        let itemLineObj = {};

        const toCallData = data.map((each) => {
          itemLineObj[each?.ItemLineNo || each?.itemLineNo] = {
            orderNo: each?.OrderNo || each?.orderNo,
            itemLineNo: each?.ItemLineNo || each?.itemLineNo,
            remarks: each?.Remarks,
            invoiceNo: each?.invoiceNo || each?.InvoiceNo,
            awbNumber: each?.awbNumber,
            status: each?.awbNumber ? '' : 'Invoiced',
          };

          return {
            orderNo: each?.OrderNo || each?.orderNo,
            itemLineNo: each?.ItemLineNo || each?.itemLineNo,
            remarks: each?.Remarks,
            invoiceNo: each?.invoiceNo || each?.InvoiceNo,
            awbNumber: each?.awbNumber,
            status: each?.awbNumber ? '' : 'Invoiced',
          };
        });

        const invoiceData = {};

        const a = toCallData?.map((each) => {
          if (!invoiceData[each?.invoiceNo]) {
            invoiceData[each?.invoiceNo] = [];
          }
          invoiceData[each?.invoiceNo].push(each?.itemLineNo);
        });

        const responses = Object.keys(invoiceData)?.map((each) => {
          return apiCall('put', `/internal/order/update`, {
            invoiceNo: each,
            username,
            id: invoiceData[each],
            status: 'Invoiced',
          });
        });

        const allResponses = await Promise.allSettled(responses);

        const resp = [];
        const res = allResponses.map((each, index) => {
          if (each?.status != 'fulfilled') {
            const a = invoiceData[Object.keys(invoiceData)?.[index]]?.map(
              (objectId) => {
                let data1 = itemLineObj[objectId];
                resp.push({ ...data1, errorMessage: each?.reason?.message });
              }
            );
          }
        });

        return resp;

        // let response = await apiCall('put', `/internal/order/update/bulk`, {
        //   data: toCallData,
        //   username,
        //   status: 'Invoiced',
        // });

        // if (response?.errorResp?.length > 0) {
        //   let resp = [];

        //   const alpha = response?.errorResp?.map((each) => {
        //     console.log(each);

        //     const a = each?.objectIds?.map((objectId) => {
        //       let data1 = itemLineObj[objectId];
        //       resp.push({ ...data1, errorMessage: each?.message });
        //     });
        //   });

        //   return resp;
        // }

        return [];
      } catch (error) {
        throw new Error(error.message);
      }
    },
  };

  const bulkActionOptions = [
    {
      label: 'Ready For PickUp',
      value: 'readyForPickup',
    },
  ];

  const bulkActionOptionsAdmin = [
    {
      label: 'Ready For PickUp',
      value: 'readyForPickup',
    },
    {
      label: 'Cancel',
      value: 'cancelOrder',
    },
    {
      label: 'Out Of Stock',
      value: 'Out Of Stock',
    },
    {
      label: 'Reassign',
      value: 'assign',
    },
    {
      label: 'Assigned To Porter',
      value: 'assignedToPorter',
    },
    {
      label: 'Assigned To Biker',
      value: 'assignedToBiker',
    },
    {
      label: 'Courier',
      value: 'courier',
    },
  ];

  const defaultConfirmationProps = {
    cancelled: [
      {
        type: 'text',
        title: 'SRT No',
        value: '',
      },
    ],
  };
  const [confirmationModalProps, setConfirmationModalProps] = useState([]);
  return (
    <div>
      <OrderPage
        type={orderStatus.invoiced}
        bulkActionOptions={isAdmin ? bulkActionOptionsAdmin : bulkActionOptions}
        defaultConfirmationProps={defaultConfirmationProps}
        confirmationModalProps={confirmationModalProps}
        setConfirmationModalProps={setConfirmationModalProps}
        uploadButtonProps={uploadButtonProps}
      />
    </div>
  );
};

export default Invoiced;
